import React from 'react';
import './InfoHeader.scss';

const InfoHeader = ({
    header,
    subheader
}) => (
    <div className="info-header">
        <span className="headline-h-400">{header}</span>
        <span className="text-md-regular">{subheader}</span>
    </div>
);

export default InfoHeader;
